export function createMagVarOptions() {
  let magVarOptions = [];

  for (let index = 90; index > 0; index--) {
    magVarOptions.push({
      itemValue: `${index}W`.padStart(3, '0'),
      itemLabel: `${index}W`.padStart(3, '0'),
    });
  }

  magVarOptions.push({ itemValue: `0`, itemLabel: `0` });

  for (let index = 1; index < 91; index++) {
    magVarOptions.push({
      itemValue: `${index}E`.padStart(3, '0'),
      itemLabel: `${index}E`.padStart(3, '0'),
    });
  }

  return magVarOptions;
}
